module.exports = __webpack_public_path__ + "img/reglamentoarbitraje.8bd04aa4.png";